import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner } from "@neru/ui";
import { Outlet } from "react-router-dom";
import { useValidSession } from "../../hooks";
export var SecureRouteWithCookie = function() {
    if (useValidSession()) {
        return /*#__PURE__*/ _jsx(Outlet, {});
    }
    return /*#__PURE__*/ _jsx(Spinner, {
        "data-testid": "pending-cookie-auth"
    });
};

//# sourceMappingURL=SecureRouteWithCookie.js.map